/// <reference path="../../jquery.d.ts" />

declare const variantData: { [key: string]: any }[];
declare const addToCartFormData: any;

module PoskiQ {
    "use strict";

    export class ProductDetail {
        public static Instance: ProductDetail = null;

        readonly SELECTED_VARIANT_BUTTON_CLASS = 'selected';

        private addToCartForm: JQuery;
        private selectedVariant: JQuery;
        private productElement: JQuery;
        private variantButtonElements: JQuery;
        private variantSelectElement: JQuery;
        private upsellOpener: JQuery;
        private attributeSelectElements: JQuery;
        private attributePriceChangeElementSelector: AttributePriceChangeElementSelectorInterface;
        private variant: any;

        public constructor() {
            this.addToCartForm = $('[data-add-to-cart-form]');
            this.productElement = $('.js-product-detail');
            this.attributeSelectElements = this.productElement.find('.variantSelect');
            this.variantSelectElement = this.productElement.find('select[name="id"]');
            this.upsellOpener = this.productElement.find('[data-upsell-component] [data-opener]');
            this.attributePriceChangeElementSelector = new AttributePriceChangeElementSelector;

            this.bindReviewButtons();

            if (this.attributeSelectElements.length) { //Use classic variant selection, if form with attributes is not set.
                this.bindSelect();
                this.processForm();
            } else {
                this.variantButtonElements = this.productElement.find('.item');
                this.selectedVariant = this.variantButtonElements.filter('.selected').first();
                this.bindVariantSelection();
                this.bindVariantButtons();
            }

            this.upsellToggle();
        }

        // Výběr varianty tlačítkem
        private bindVariantButtons() {
            this.variantButtonElements.each((i, e) => {
                e.addEventListener('click', e => {
                    const btn = <HTMLElement>e.currentTarget;
                    const variantId = btn.dataset.variantId;
                    let variant = variantData.filter((element) => element.id == variantId).shift();
                    this.variantButtonElements.removeClass(this.SELECTED_VARIANT_BUTTON_CLASS);
                    btn.classList.add(this.SELECTED_VARIANT_BUTTON_CLASS);
                    this.applyVariantToPage(variant);
                });
            });
            this.variantButtonElements.first().trigger('click');
        }

        private upsellToggle = function () {
            this.upsellOpener.on('click', function (event) {
                $(event.target).parent().toggleClass('is-active');
            }.bind(this));
        };

        // Výběr variant z roletky
        private bindVariantSelection(): void {
            const that = this;
            this.variantSelectElement.on('change', function (event: JQueryEventObject) {
                const variantId = this.value;
                let variant = variantData.filter((element) => element.id == variantId).shift();

                that.applyVariantToPage(variant);
            }).trigger('change');
        }

        private applyVariantToPage(variant): void {
            this.variant = variant;
            var setSpecificationHtmlOrHideIfEmpty = function (element: JQuery, html: string) {
                if (element.length == 0)
                    return;
                element.html(html);
                var container = element.closest('.js-variant-data-block');
                container.toggleClass('hidden', !html);
            };
            setSpecificationHtmlOrHideIfEmpty($('.js-availability'), variant.availability);
            setSpecificationHtmlOrHideIfEmpty($('.js-code'), variant.code);
            setSpecificationHtmlOrHideIfEmpty($('.js-oldPrice'), variant.oldPrice);
            setSpecificationHtmlOrHideIfEmpty($('.js-oldPriceVAT'), variant.oldPriceVAT);
            setSpecificationHtmlOrHideIfEmpty($('.js-price'), variant.price);
            setSpecificationHtmlOrHideIfEmpty($('.js-priceVAT'), variant.priceVAT);

            if (variant.bySelector) {
                const bySelector: Array<{ selector: string, html: string|null }> = variant.bySelector;
                bySelector.forEach(function(one) {
                    $(one.selector).html(one.html);
                });
            }

            let buttonSalable = $('.js-submit-salable');
            let buttonInquirable = $('.js-submit-inquirable');
            let buttonDisabled = $('.js-submit-disabled');

            buttonSalable.addClass('hidden');
            buttonInquirable.addClass('hidden');
            buttonDisabled.addClass('hidden');
            if (variant.salable) {
                buttonSalable.removeClass('hidden');
            } else if (variant.inquirable) {
                buttonInquirable.removeClass('hidden');
            } else {
                buttonDisabled.removeClass('hidden');
            }

            // uprav formular
            if (variant.salable) {
                this.adaptAddToCartForm(addToCartFormData.cart, variant);
            } else if (variant.inquirable) {
                const inquiry = JSON.parse(JSON.stringify(addToCartFormData.inquiry));
                inquiry.url = inquiry.url + '?id=' + variant.id
                this.adaptAddToCartForm(inquiry, variant);
            }

            $('.js-precart').change();
            document.dispatchEvent(new CustomEvent('productVariantChanged', { detail: variant }));
        }

        // Formulář pro výběr podle atributů
        private bindSelect(): void {
            this.attributeSelectElements.each(function (index, element) {
                $(element).on('change', function () {
                    this.processForm();
                }.bind(this));
            }.bind(this));
        }

        private processForm() {
            let selectedAttributeValues = [];
            this.attributeSelectElements.each(function (i) {
                selectedAttributeValues.push($(this).children("option:selected").attr('value'));
            });
            let variant = this.findVariant(selectedAttributeValues);

            if (variant == null) {
                variant = {};
            }
            this.editVariantNames(selectedAttributeValues);
            this.variantSelectElement.val(variant.id);
            return this.applyVariantToPage(variant);
        }

        private editVariantNames(selectedAttributeValues: any[]) {
            this.attributeSelectElements.each(function (index, element) {
                let originalValue = selectedAttributeValues[index];
                $(element).children("option").each(function (ind, elem) {
                    selectedAttributeValues[index] = elem.getAttribute('value');
                    let variant = this.findVariant(selectedAttributeValues);
                    let textToDisplay = '&nbsp;';
                    let unavailable = $('.js-submit-disabled').first().text().toLowerCase();
                        if (variant != null) {
                            textToDisplay = variant.priceChange;
                        } else {
                            textToDisplay = unavailable;
                        }
                        textToDisplay = ' (' + textToDisplay + ')';
                    let selectedAttribute = this.attributePriceChangeElementSelector.select(elem, ind);
                    $(selectedAttribute).find('[data-price-change]').remove();
                    $(selectedAttribute).append('<div data-price-change="">' + textToDisplay + '</div>');
                }.bind(this));

                selectedAttributeValues[index] = originalValue;
            }.bind(this));
        }

        private findVariant(attributes: any[]): any {
            for (let i in variantData) {
                if (!variantData.hasOwnProperty(i))
                    continue;
                let variant = variantData[i];

                let doesNotFit = false;
                for (let attribute in attributes) {
                    let array = variant.variantSelectAttributeValues;
                    if (array.indexOf(parseInt(attributes[attribute])) <= -1) {
                        doesNotFit = true;
                        break;
                    }
                }
                if (doesNotFit) {
                    continue;
                }

                return variant;
            }

            return null;
        }

        private adaptAddToCartForm(cartType: any, variant: any): void {
            this.addToCartForm.removeClass(cartType.removeClass);
            this.addToCartForm.addClass(cartType.class);
            this.addToCartForm.attr('action', cartType.url);
            this.addToCartForm.find('select[name=id]').first().val(variant.id);
        }

        private bindReviewButtons() {
            let tabElement = jQuery('[data-product-detail-reviews-tab]');
            if (tabElement.length > 0) {
                jQuery('[data-show-product-reviews-btn]').on('click', function (e) {
                    e.preventDefault();
                    tabElement.trigger('click');
                    window.setTimeout(function () {
                        window.location.href = '#detail_recenze';
                    }, 1000);
                });
            }
        }

        public setAttributePriceChangeElementSelector(attributePriceChangeElementSelector: AttributePriceChangeElementSelectorInterface) {
            this.attributePriceChangeElementSelector = attributePriceChangeElementSelector;
            if(this.attributeSelectElements.length) {
                this.processForm();
            }
        }

        public getVariant(): any {
            return this.variant;
        }
    }

    export interface AttributePriceChangeElementSelectorInterface {
        select(attributeValueElement, index: number);
    }

    class AttributePriceChangeElementSelector implements AttributePriceChangeElementSelectorInterface{
        public select(attributeValueElement, index: number) {
            return $(attributeValueElement).parent().closest('.SumoSelect').find('.optWrapper li').eq(index).children('label');
        }
    }

    $(function () {
        if (!document.body.className.match(/location_product_getDetail/))
            return;

        if(!ProductDetail.Instance) {
            ProductDetail.Instance = new ProductDetail();
        }
    });

    $(function () {
        //odkazy na jednotlive taby v detailu produktu
        function showTab(tab) {
            $('.idBox').css("display", "none");
            $('.idBox' + tab).css("display", "block");
            $('.tabs-holder .idTabs li a').removeClass('selected');
            $('.tabs-holder .idTabs li a[href$="' + tab + '"]').addClass('selected');
        }

        // odkazy na preposilaci a kontaktni formular v detailu (po odeslani)
        let form = window.location.hash;
        if ((form == '#contact-form' || form == '#send-to-friend-form') && $('.tabs-holder').length) {
            showTab(form);
        }

        $('.js-product-description-link').click(() => {
            showTab('#text');
        });
        $('.js-product-contact-link').click(() => {
            showTab('#contact-form');
        });
        $('.js-product-send-to-friend-link').click(() => {
            showTab('#send-to-friend-form');
        });

    });

}
